import SideMenu from '@/containers/side-menu/SideMenu.vue';
const RegisterPark = () => import('@/pages/register-park/RegisterPark.vue');

export default {
  path: '/register-park',
  name: 'RegisterPark',
  components: {
    mainContent: RegisterPark,
    mainMenu: SideMenu,
  },
  meta: {
    role: {
      sectorId: 'register-park',
    },
    breadcrumb: {
      title: 'Cadastro de Estacionamento',
      paths: [{ title: 'Painel de Controle' }, { title: 'Estacionamento' }],
    },
  },
};
